<template>
	<div>
		<input type="hidden" :value="calcularValores">
		<div class="col-12 col-sm-12 col-md-12 col-lg-12">
			<div class="table-finanzas">
				<CLoader :pConfigLoad="ConfigLoad">
					<template slot="BodyFormLoad">
						<table class="table-fin-05">
							<thead>
								<tr>
									<th class="sticky mediana marca"><b>Descripción</b></th>
									<th class="mediana text-center">Plan</th>
									<th class="mediana text-center">%</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item,index) in ListaDetalle" :key="index">
									<td :class="item.Descripcion === 'Facturacion' ? 'sticky borde_bajo' : 'sticky' ">
										<b>{{item.Descripcion}}</b>
									</td>
									<template>
										<td v-if="item.Descripcion === 'Facturacion'" :class="item.Descripcion === 'Facturacion' ? 'sticky borde_bajo' : 'sticky' "><Cmoneda :activo="false" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan" />  </td>
										<td v-if="item.Descripcion === 'Materiales'"><Cmoneda :activo="false" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan"/>  </td>
										<td v-if="item.Descripcion === 'Equipos'"><Cmoneda :activo="false" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan"/>  </td>
										<td v-if="item.Descripcion === 'Mano de Obra'"><Cmoneda :activo="false" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan"/>  </td>
										<td v-if="item.Descripcion === 'Vehiculos'"><Cmoneda :activo="false" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan"/>  </td>
										<td v-if="item.Descripcion === 'Contratistas'"><Cmoneda :activo="false" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan"/>  </td>
										<td v-if="item.Descripcion === 'Viaticos'"><Cmoneda :activo="false" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan"/>  </td>
										<td v-if="item.Descripcion === 'Burden'"><Cmoneda :activo="false" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan"/>  </td>
									</template>
									<td v-if="item.Descripcion === 'Facturacion' " :class="item.Descripcion === 'Facturacion' ? 'sticky borde_bajo' : 'sticky' "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
									<td v-if="item.Descripcion === 'Materiales'  "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
									<td v-if="item.Descripcion === 'Equipos'  "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
									<td v-if="item.Descripcion === 'Mano de Obra'  "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
									<td v-if="item.Descripcion === 'Vehiculos'  "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
									<td v-if="item.Descripcion === 'Contratistas'  "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
									<td v-if="item.Descripcion === 'Viaticos'  "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
									<td v-if="item.Descripcion === 'Burden'  "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
								</tr>
							</tbody>
							<tfoot>
								<tr>
									<td class="color-01 bold sticky marca">Costo Operacional</td>
									<td><Cmoneda 	 :activo="true" :minus="true" :clase="'form-control form-finanza form-control-sm color-01 bold text-center'"  currency="$" separator="," :precision="2" v-model="CostoOpPlan"/></td>
									<td><Cporcentaje :activo="true" :minus="true" :clase="'form-control form-finanza form-control-sm color-01 bold text-center'"  currency="%" separator="," :precision="2" v-model="CostoOpPlanPorcent"/></td>
								</tr>
								<tr>
									<td class="color-01 bold sticky marca">Gross Profit</td>
									<td><Cmoneda 	 :activo="true" :minus="true" :clase="'form-control form-finanza form-control-sm color-01 bold text-center'"  currency="$" separator="," :precision="2" v-model="GpPlan"/></td>
									<td><Cporcentaje :activo="true" :minus="true" :clase="'form-control form-finanza form-control-sm color-01 bold text-center'"  currency="%" separator="," :precision="2" v-model="GpPlanPorcent"/></td>
								</tr>
							</tfoot>
						</table>
					</template>
				</CLoader>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props:['poBtnSave','pIdContrato','pIdCliente','pIdClienteS','pFecha','pIdConfigS','pIdTipoSer','pIdClienteS'],
	data() {
		return {
			Modal:true,
            FormName:'Spend Plan',
            EmitSeccion:this.poBtnSave.EmitSeccion,
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
			Fecha:'',
			Anio:'',
			Mes:'',
			IdCliente:'',
			IdClienteS:'',
			IdContrato:'',
			IdConfigS:'',
			IdTipoSer:'',
			ListaDetalle:[
				{Descripcion:'',MontoPlan:0,PorcenPlan:0},
				{Descripcion:'',MontoPlan:0,PorcenPlan:0},
				{Descripcion:'',MontoPlan:0,PorcenPlan:0},
				{Descripcion:'',MontoPlan:0,PorcenPlan:0},
				{Descripcion:'',MontoPlan:0,PorcenPlan:0},
				{Descripcion:'',MontoPlan:0,PorcenPlan:0},
				{Descripcion:'',MontoPlan:0,PorcenPlan:0},
				{Descripcion:'',MontoPlan:0,PorcenPlan:0},
			],
			CostoOpPlan:'',
            CostoOpPlanPorcent:'',
            GpPlan:'',
			GpPlanPorcent:'',
			SpendPlan:{
            },
		}
	},
	methods: {
		Guardar(){
			let formData=new FormData();
			this.poBtnSave.disableBtn=true;
			formData.set('Anio',this.Anio);
			formData.set('Mes',this.Mes);
			formData.set('IdCliente',this.IdCliente);
			formData.set('IdClienteS',this.IdClienteS);
			formData.set('IdContrato',this.IdContrato);
			formData.set('IdConfigS',this.IdConfigS);
			formData.set('IdTipoServ',this.IdTipoSer);
			this.ListaDetalle.forEach(element => {
				switch (element.Descripcion) {
					case 'Facturacion':
						formData.set('FacturacionPMensual',element.MontoPlan);
						break;
					case 'Materiales':
						formData.set('Materiales',element.MontoPlan);
						break;
					case 'Equipos':
						formData.set('Equipos',element.MontoPlan);
						break;
					case 'Mano de Obra':
						formData.set('ManoDeObra',element.MontoPlan);
						break;
					case 'Vehiculos':
						formData.set('Vehiculos',element.MontoPlan);
						break;
					case 'Contratistas':
						formData.set('Contratistas',element.MontoPlan);
						break;
					case 'Burden':
						formData.set('Burden',element.MontoPlan);
						break;
					case 'Viaticos':
						formData.set('Viaticos',element.MontoPlan);
						break;
				}
			});
			this.$http.post('spendplanguardar',formData).then((res)=>{
				this.$toast.success('Plan Guardado Correctamente');
				this.poBtnSave.disableBtn=false;
				$('#'+this.EmitSeccion).modal('hide');
			}).catch((err) => {
				this.$toast.warning(err.response.data.message.errores);
			});
		},
		GetData(){
			this.ConfigLoad.ShowLoader=true;
			this.$http.get('actualizarfacturaservicios/get',{
				params:{
					IdConfigS:this.IdConfigS,
					IdTipoServ:this.IdTipoSer,
					Anio:this.Anio,
					Mes:this.Mes,
					IdCliente:this.IdCliente,
					IdClienteS:this.IdClienteS,
					IdContrato:this.IdContrato,
				}
			}).then((res)=>{
				this.ListaDetalle 			= res.data.data.row;
				let valores 	  			= res.data.data.rowconfig;
				this.CostoOpPlan 			= valores.CostoOperacion.MontoPlan;
				this.CostoOpPlanPorcent 	= valores.CostoOperacion.PorcentPlan;
				this.GpPlan 				= valores.GrossProfit.MontoPlan;
				this.GpPlanPorcent			= valores.GrossProfit.PorcentPlan;
			}).finally(()=>{
				this.ConfigLoad.ShowLoader = false;
			})
		},
		getPorcent($monto,$montoDivisor){
			let PORCENTAJE_FINA = 0;
			if (parseFloat($monto)  > 0) {
				if (parseFloat($montoDivisor) > 0){
					let decimal = ( parseFloat($monto) / parseFloat($montoDivisor) );
					let porcenTemp= (decimal * 100);
					porcenTemp = porcenTemp.toFixed(2);
					PORCENTAJE_FINA = (porcenTemp > 100) ? 100 : porcenTemp;
				}
			}
			return PORCENTAJE_FINA;
		}
	},
	created() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
		this.bus.$on("NewModal_"+this.EmitSeccion, (data, Id) => {
			this.ConfigLoad.ShowLoader=true;
			this.IdClienteS = this.pIdClienteS;
			this.IdCliente = this.pIdCliente;
			this.IdConfigS = this.pIdConfigS;
			this.IdTipoSer = this.pIdTipoSer;
			this.IdContrato = this.pIdContrato;
			
			this.Fecha=this.pFecha;
			// let formatedDateInicio=this.Fecha.getDate()+'-'+(this.Fecha.getMonth()+1)+'-'+this.Fecha.getFullYear();

			this.Anio = this.Fecha.getFullYear();
			this.Mes = this.Fecha.getMonth()+1;
			this.GetData();

			this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
		})
	},
	computed:{
		calcularValores(){
			let PlanFacturacion = 0;
			let CostoOpPlan = 0;
			for(let i=0;i<this.ListaDetalle.length;i++){
				if(i>0){
					if(this.ListaDetalle[i].Descripcion != '') {
						if( isNaN(this.ListaDetalle[i].MontoPlan) ) {
							CostoOpPlan += 0;
						}else {
							CostoOpPlan += parseFloat(this.ListaDetalle[i].MontoPlan);
						}
						// PORCENTAJE DE COLUMNA DE PLAN DE FACTURACIÓN
						this.ListaDetalle[i].PorcentPlan = this.getPorcent(this.ListaDetalle[i].MontoPlan, PlanFacturacion);
                    }
				}
				else {

                    if( isNaN(this.ListaDetalle[i].MontoPlan) ) {
						PlanFacturacion += 0;
                    }else {
						PlanFacturacion += parseFloat(this.ListaDetalle[i].MontoPlan);
					}
                }
			}
			this.CostoOpPlan 				= CostoOpPlan.toFixed(2);
			this.CostoOpPlanPorcent 		= this.getPorcent(CostoOpPlan, PlanFacturacion);
			let montoGP						= (PlanFacturacion - CostoOpPlan);
			this.GpPlan 					= montoGP;
			this.GpPlanPorcent				= this.getPorcent (montoGP, PlanFacturacion);
		}
	}
}
</script>

<style>

</style>
